import { useEffect, useState } from "react";
import styled from "styled-components";
import { sendAuthTokenAsJSMessage } from "../Helpers/SendJSMessage";
import { useTranslate } from '@tolgee/react';
import SpinnerComponent from "../Components/GenericComponents/SpinnerComponent";
import { colors } from "../Assets/styles/colors";
import { ReactComponent as MicrosoftLogo } from "../Assets/icons/logo/microsoftLogo.svg";
import { ReactComponent as GoogleLogo } from "../Assets/icons/logo/google.svg";
import { ReactComponent as AppleLogo } from "../Assets/icons/logo/apple-logo.svg";
import { useAuthService } from "../Context/AuthContext";

import { useSearchParams } from "react-router-dom";
import { useNotify } from "../Helpers/Notifications";

const LoginForTokenPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { getCurrentUser, getMicrosoftSSOLoginLink, getGoogleSSOLoginLink } =
    useAuthService();
  const { t } = useTranslate();
  const [searchParams, setSearchParasm] = useSearchParams();
  const { notifySuccess, notifyError, notifyInfo } = useNotify();
  // Simulate login and send the token back to the parent (Outlook taskpane)

  const handleLogin = (link) => {
    window.location.replace(link);
  };

  const navigateToTerms = (to) => {
    window.open("https://www.emotii.ai/terms");
  };

  const onLoginMicrosoftSubmit = () => {
    setIsLoading(true);
    getMicrosoftSSOLoginLink(
      true,
      (response) => {
        setIsLoading(false);
        const microsoftLink = response.data.redirect_url;
        handleLogin(microsoftLink);
      },
      (error) => {
        setIsLoading(false);
        notifyError(`${t('general.something_wrong')}`);
      }
    );
  };

  const onLoginGoogleSubmit = () => {
    getGoogleSSOLoginLink(
      true,
      (response) => {
        setIsLoading(false);
        const googleLink = response.data.redirect_url;

        handleLogin(googleLink);
      },
      (error) => {
        setIsLoading(false);
        notifyError(`${t('general.something_wrong')}`);
      }
    );
  };

  useEffect(() => {
    const tokenFromUrl = searchParams.get("token");
    const email = searchParams.get("email");
    if (tokenFromUrl && email) {
      sendAuthTokenAsJSMessage(tokenFromUrl, email);
    }
  }, []);

  return (
    <SpinnerComponent isLoading={isLoading}>
      <FirstWrapper>
        <LoginPageContainer>
          <Container>
            <Content>
              <Card>
                <Group>
                  <h1 style={{ marginBottom: "20px" }}>
                    {t('login.login')}
                  </h1>
                  <LoginButton
                    id="sign-in-sso"
                    onClick={(e) => onLoginMicrosoftSubmit(e)}
                  >
                    <MicrosoftLogo />
                    {t('login.loginSSO')}
                  </LoginButton>
                  <LoginButton
                    id="sign-in-sso"
                    onClick={(e) => onLoginGoogleSubmit(e)}
                  >
                    <GoogleLogo />
                    {t('login.loginGoogleSSO')}
                  </LoginButton>
                  <TermsInfo onClick={() => navigateToTerms()}>
                    <p>
                      {t('login.login_agree')}
                      <br />
                      <span>
                        {t('general.terms_and_conditions')}
                      </span>
                    </p>
                  </TermsInfo>
                </Group>
              </Card>
            </Content>
          </Container>
        </LoginPageContainer>
      </FirstWrapper>
    </SpinnerComponent>
  );
};

export default LoginForTokenPage;

const LoginPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
const FirstWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 20px;
  padding-bottom: 20px;
  overflow: hidden;
  @media (max-width: 1440px) {
    margin: 0;
    padding: 0;
  }
`;
const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 500px;
  width: 100%;
  gap: 20px;
  margin-top: auto;
  margin-bottom: auto;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  h1 {
    color: ${colors.white};
    font-size: 32px;
    font-weight: 600;
    line-height: 39px;
    letter-spacing: 0px;
    text-align: center;
  }
  input {
    padding: 14px 16px;
    color: ${colors.white};
    background: ${colors.newChatModalInputBg};
    border-radius: 10px;
    border: none;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    &:focus {
      outline: none;
    }
  }
`;
const LoginButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: ${colors.purple};
  color: ${colors.white};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  text-align: center;
  border: none;
  border-radius: 10px;
  padding: 14px 15px;
  cursor: pointer;
  svg {
    height: 20px;
    width: 20px;
  }
  &:disabled {
    opacity: 0.5;
  }
`;
const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 32px;
`;

const TermsInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    color: #b5b8cd;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
  }

  span {
    cursor: pointer;
    color: ${colors.purple};
    font-weight: 600;
    line-height: 22px;
    text-align: center;
    text-decoration: underline;
  }
`;

const Line = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
`;
const Description = styled.p`
  color: #ffffff80;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0px;
  text-align: left;
`;
